import * as React from "react";
const SvgFiRrHouseNight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-house-night_svg__a)">
      <path
        fill="#062147"
        d="M8.581 9.595C6.676 8.711 6 7.77 6 6s.675-2.711 2.58-3.595A1 1 0 0 0 8.595.598 5.9 5.9 0 0 0 6 0C2.691 0 0 2.691 0 6s2.691 6 6 6c.906 0 1.78-.201 2.597-.598a1 1 0 0 0-.016-1.807M2 6a4.005 4.005 0 0 1 3.554-3.975C4.492 3.053 4 4.34 4 6s.492 2.947 1.554 3.975A4.005 4.005 0 0 1 2 6m20.465 6.588-3.5-2.739a3.99 3.99 0 0 0-4.93 0l-3.5 2.739A3.98 3.98 0 0 0 9 15.738v4.261c0 2.206 1.794 4 4 4h7c2.206 0 4-1.794 4-4v-4.261a3.98 3.98 0 0 0-1.535-3.151zM22 20c0 1.103-.897 2-2 2h-7c-1.103 0-2-.897-2-2v-4.261c0-.619.28-1.193.768-1.576l3.5-2.738a1.995 1.995 0 0 1 2.464 0l3.5 2.738c.488.383.768.957.768 1.576zm-4-3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1m1-10.54a.63.63 0 0 1 .404-.573l1.082-.41.433-1.084a.626.626 0 0 1 1.16 0l.436 1.09 1.09.436a.626.626 0 0 1 0 1.16l-1.09.436-.436 1.09a.626.626 0 0 1-1.16 0l-.438-1.097-1.099-.463A.62.62 0 0 1 19 6.458zM6.5 18.5a.75.75 0 0 1-.472.697l-1.308.523-.523 1.308a.75.75 0 0 1-1.394 0l-.526-1.316-1.318-.556a.75.75 0 0 1 .025-1.392l1.299-.492.52-1.301a.75.75 0 0 1 1.394 0l.523 1.308 1.308.523a.75.75 0 0 1 .472.698M10 3.444a.88.88 0 0 1 .565-.802l1.515-.574.607-1.518a.876.876 0 0 1 1.626 0l.611 1.526 1.526.611a.876.876 0 0 1 0 1.626l-1.526.611-.611 1.527a.876.876 0 0 1-1.626 0l-.614-1.536-1.538-.648A.875.875 0 0 1 10 3.444"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-house-night_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHouseNight;
